export default function handleRelianceIPAChangeHelper(event, formik) {
  const { setFieldValue, values } = formik;

  const name = event.target.name;
  const isChecked = event.target.checked;

  if (name === "proposerDetails.IsPermanentSameasCommAddr") {
    // console.log("isChecked: ", isChecked);
    if (isChecked === true) {
      setFieldValue(
        "proposerDetails.PermanentAddress.Pincode",
        values.proposerDetails.CommunicationAddress.Pincode
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.Address1",
        values.proposerDetails.CommunicationAddress.Address1
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.Address2",
        values.proposerDetails.CommunicationAddress.Address2
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.Address3",
        values.proposerDetails.CommunicationAddress.Address3
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.NearestLandmark",
        values.proposerDetails.CommunicationAddress.NearestLandmark
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.CityID",
        values.proposerDetails.CommunicationAddress.CityID
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.City",
        values.proposerDetails.CommunicationAddress.City
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.DistrictID",
        values.proposerDetails.CommunicationAddress.DistrictID
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.District",
        values.proposerDetails.CommunicationAddress.District
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.AreaID",
        values.proposerDetails.CommunicationAddress.AreaID
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.Area",
        values.proposerDetails.CommunicationAddress.Area
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.StateID",
        values.proposerDetails.CommunicationAddress.StateID
      );
      setFieldValue(
        "proposerDetails.PermanentAddress.State",
        values.proposerDetails.CommunicationAddress.State
      );
      // To show selected option in the pincode field
      setFieldValue(
        "proposerDetails.auto_field_key",
        values.proposerDetails.CommunicationAddress.Pincode
      );
      // making read only
      document
        .getElementById(`proposerDetails.PermanentAddress.Pincode`)
        .setAttribute("readonly", true);
      document
        .getElementById(`proposerDetails.PermanentAddress.Address1`)
        .setAttribute("readonly", true);
      document
        .getElementById(`proposerDetails.PermanentAddress.Address2`)
        .setAttribute("readonly", true);
      document
        .getElementById(`proposerDetails.PermanentAddress.Address3`)
        .setAttribute("readonly", true);
      document
        .getElementById(`proposerDetails.PermanentAddress.NearestLandmark`)
        .setAttribute("readonly", true);
    } else {
      setFieldValue("proposerDetails.PermanentAddress.Pincode", "");
      setFieldValue("proposerDetails.PermanentAddress.Address1", "");
      setFieldValue("proposerDetails.PermanentAddress.Address2", "");
      setFieldValue("proposerDetails.PermanentAddress.Address3", "");
      setFieldValue("proposerDetails.PermanentAddress.NearestLandmark", "");
      setFieldValue("proposerDetails.PermanentAddress.CityID", "");
      setFieldValue("proposerDetails.PermanentAddress.City", "");
      setFieldValue("proposerDetails.PermanentAddress.DistrictID", "");
      setFieldValue("proposerDetails.PermanentAddress.District", "");
      setFieldValue("proposerDetails.PermanentAddress.AreaID", "");
      setFieldValue("proposerDetails.PermanentAddress.Area", "");
      setFieldValue("proposerDetails.PermanentAddress.StateID", "");
      setFieldValue("proposerDetails.PermanentAddress.State", "");
      // To show selected option in the pincode field
      setFieldValue("proposerDetails.auto_field_key", "");
      // making editable
      document
        .getElementById(`proposerDetails.PermanentAddress.Pincode`)
        .removeAttribute("readonly");
      document
        .getElementById(`proposerDetails.PermanentAddress.Address1`)
        .removeAttribute("readonly");
      document
        .getElementById(`proposerDetails.PermanentAddress.Address2`)
        .removeAttribute("readonly");
      document
        .getElementById(`proposerDetails.PermanentAddress.Address3`)
        .removeAttribute("readonly");
      document
        .getElementById(`proposerDetails.PermanentAddress.NearestLandmark`)
        .removeAttribute("readonly");
    }
  }
}
